import React from "react";
import { useRouteMatch, Switch, Redirect } from "react-router-dom";
import { DefaultLayout } from "../DefaultLayout";
import { PrivateRoute } from "../../auth/PrivateRoute";
import { OperationsList } from "./Operations";
import { VisualInspectionPage } from "../../testCommunication/visualInspection/VisualInspectionPage";
import { WetLeakagePage } from "../../testCommunication/wetLeakage/WetLeakagePage";
import { DiodeTestPage } from "../../testCommunication/diodeTest/DiodeTestPage";
import { ColorTestPage } from "../../testCommunication/colorimeter/ColorTestPage";
import { Intake } from "../../intake/IntakeRoutes";
import { FlashDetailsUI } from "../../common/FlashDetailsUI";
import { EdgeFileUpload } from "../../projectManagement/components/fileUpload/EdgeFileUpload";
import { InsulationTestPage } from "../../testCommunication/InsulationTest/InsulationTestPage";
import { UploadLSDBCloud } from "../../testCommunication/cloudUpload/UploadLSDBCloud";


export const Operations = () => {
  const { path } = useRouteMatch();

  return (
    <DefaultLayout>
      <Switch>
        <PrivateRoute exact path={`${path}`} component={OperationsList} />
        <PrivateRoute path={`${path}/wet_leakage`} component={WetLeakagePage} />
        <PrivateRoute path={`${path}/diode_test`} component={DiodeTestPage} />
        <PrivateRoute
          path={`${path}/visual_inspection`}
          component={VisualInspectionPage}
        />
        <PrivateRoute path={`${path}/colorimeter`} component={ColorTestPage} />
        <PrivateRoute path={`${path}/intake`} component={Intake} />
        <PrivateRoute
          exact
          path={`${path}/flash_details`}
          component={FlashDetailsUI}
        />

        <PrivateRoute
          exact
          path={`${path}/edge_upload/`}
          component={EdgeFileUpload}
        />
         <PrivateRoute
          exact
          path={`${path}/insulation_test/`}
          component={InsulationTestPage}
        />

        <PrivateRoute
          exact
          path={`${path}/upload_cloud/`}
          component={UploadLSDBCloud}
        />

        <Redirect to="/not_found" />
      </Switch>
    </DefaultLayout>
  );
};
